import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../helper/Helper";

const initialState = {
    isLoading: false,
    isCreated: false,
    isUpdate : false,
    isDelete : false,
    products: [],
    singleProduct : [],
    totalPage: "",
}
export const create = createAsyncThunk(
    "/create",
    async (formData) => {
        let res = await axiosInstance.post("/product/create", formData);
        let resData = await res?.data;
        return resData;
    }
);
export const productList = createAsyncThunk(
    "/productList",
    async (data) => {
        let res = await axiosInstance.post(`/product/list`, data);
        let resData = await res?.data;
        return resData;
    }
);
export const productDetails = createAsyncThunk(
    "/productDetails",
    async (id) => {
        let res = await axiosInstance.get(`/product/detail/${id}`);
        let resData = await res?.data;
        return resData;
    }
);
export const updateProduct = createAsyncThunk(
    "/updateProduct",
    async (data) => {
        let res = await axiosInstance.post(`/product/update`, data);
        let resData = await res?.data;
        return resData;
    }
);
export const deleteProduct = createAsyncThunk(
    "/deleteProduct",
    async (data) => {
        let res = await axiosInstance.post("/product/remove", data);
        let resData = await res?.data;
        return resData;
    }
);
export const CrudSlice = createSlice({
    name: 'crud',
    initialState,
    reducers: {

    },
    extraReducers: (build) => {
        build
            .addCase(create.pending, (state, { payload }) => {
                state.isLoading = true;
                state.isCreated = false;
                state.isError = null;
            })
            .addCase(create.rejected, (state, { payload }) => {
                state.isLoading = false;
                state.isCreated = false;

            })
            .addCase(create.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                if (payload.status === 200) {
                    state.isCreated = true;
                } else {
                    state.isError = payload.message
                }
            })
            .addCase(productList.pending, (state, { payload }) => {
                state.isLoading = true;
                state.isError = null;
                state.isCreated = false;
                state.isUpdate = false;
            })
            .addCase(productList.rejected, (state, { payload }) => {
                state.isLoading = false;
            })
            .addCase(productList.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.products = payload.data;
                state.totalPage = payload.totalPages;
            })
            .addCase(productDetails.pending, (state, { payload }) => {
                state.isLoading = true;
                state.isError = null;
               
            })
            .addCase(productDetails.rejected, (state, { payload }) => {
                state.isLoading = false;
            })
            .addCase(productDetails.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.singleProduct = payload.data;
                
            })
            .addCase(updateProduct.pending, (state, { payload }) => {
                state.isLoading = true;
                state.isError = null;
                state.isUpdate = false;
            })
            .addCase(updateProduct.rejected, (state, { payload }) => {
                state.isLoading = false;
            })
            .addCase(updateProduct.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.isUpdate = true;
            })
            .addCase(deleteProduct.pending, (state, { payload }) => {
                state.isLoading = true;
                state.isError = null;
                state.isDelete = false;
            })
            .addCase(deleteProduct.rejected, (state, { payload }) => {
                state.isLoading = false;
            })
            .addCase(deleteProduct.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.isDelete = true;
            })
    }
});